import {
  Dashboard as DashboardIcon,
  // AdminPanelSettings as AdminIcon,
  Business as CompanyIcon,
  CardMembership as SubscriptionIcon,
  Description as TemplateIcon,
  Email as EmailIcon,
  SmartToy as ChatbotIcon,
  QuestionAnswer as QnaIcon,
  Analytics as AnalyticsIcon,
  // Payment as PaymentIcon,
} from "@mui/icons-material";

import { MenuDto } from "@/dto/MenuDto";
import Router from "@/constants/router";
import { AdmAuth } from "./code";

export const DRAWER_WIDTH: number = 260;

export const MENU_LIST: MenuDto[] = [
  {
    title: "대시보드",
    path: Router.Dashboard,
    icon: DashboardIcon,
    auth: [AdmAuth.Admin],
  },
  {
    title: "도장 관리",
    path: Router.CompanyStamp,
    icon: CompanyIcon,
    auth: [AdmAuth.Admin],
  },
  {
    title: "구독 상품 관리",
    path: Router.Subscription,
    icon: SubscriptionIcon,
    auth: [AdmAuth.Admin],
  },
  // {
  //   title: "분할결제 설정",
  //   path: Router.InstallmentSetting,
  //   icon: PaymentIcon,
  //   auth: [AdmAuth.Admin],
  // },
  {
    title: "템플릿 관리",
    path: Router.Template,
    icon: TemplateIcon,
    auth: [AdmAuth.Admin],
  },
  {
    title: "이메일 대량 발송",
    path: Router.BulkEmail,
    icon: EmailIcon,
    auth: [AdmAuth.Admin],
  },
  {
    title: "챗봇 관리",
    icon: ChatbotIcon,
    auth: [AdmAuth.Admin],
    children: [
      {
        title: "QNA 컨텐츠 관리",
        path: Router.SuperChatContent,
        icon: QnaIcon,
        auth: [AdmAuth.Admin],
      },
      {
        title: "채팅 로그 분석",
        path: Router.SuperChatLogDashboard,
        icon: AnalyticsIcon,
        auth: [AdmAuth.Admin],
      },
    ],
  },
  // {
  //   title: "관리자 관리",
  //   path: Router.Admins,
  //   icon: AdminIcon,
  //   auth: [AdmAuth.Admin],
  // },
];
